import React, { useState, useEffect, useContext } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import { PopUpContext } from "../../contexts/popUpContext";

import lbl from "../../data/Labels.json";

const FinancePayableList = ({ activeYear, data }) => {
  const payablesColumns = [
    { path: "id", label: "شماره" },
    {
      path: "verification_date",
      label: "تاریخ",
    },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "verified_by_staff_name", label: "تایید کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "amount", label: "قابل پرداخت" },
    {
      path: "option",
      content: (e) => (
        <Option
          Delete={{ route: "contractors/payable", id: e.id }}
          Edit={{
            form: "contractor-payable-form",
            cache: e.contractor_id,
            edit: e,
          }}
        />
      ),
    },
  ];

  const { popUp } = useContext(PopUpContext);

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      const filteredData = data?.data[0]?.payables.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );

      getRows(filteredData);
    }
  }, [activeYear, popUp, data]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payables}</p>
      <Table
        data={rows}
        columns={payablesColumns}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePayableList;
